import { forwardRef, useMemo } from 'react';
import {
  Child,
  ChildrenContainer,
  IconContainer,
  Notice,
  StyledLoader,
} from './styles';
import { NavLink } from 'react-router-dom';
import { NavIcon } from 'components/Kizen/Icon';
import { TextEllipsisWithTooltip } from 'components/Kizen/Table';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { iconOptions } from 'components/MultiColumnBuilder/components/IconSelector';

const getLabel = (item) => {
  return item?.display_names?.records?.[0]?.display_name ?? '';
};

export const DynamicChildren = forwardRef(
  (
    { mobile, offset, shouldShrinkToLeft, parent, dynamicItemConfig },
    forwardedRef
  ) => {
    const { t } = useTranslation();
    const { data, isFetching } = useQuery({
      queryKey: dynamicItemConfig?.queryKey,
      queryFn: dynamicItemConfig?.queryFn,
      staleTime: 0,
      enabled: !!dynamicItemConfig,
    });

    const items = data?.data?.results ?? [];

    const iconOptionsLookup = useMemo(
      () =>
        iconOptions.reduce((acc, el) => {
          acc[el.value] = el;
          return acc;
        }, {}),
      []
    );

    return (
      <ChildrenContainer
        collapse
        ref={forwardedRef}
        mobile={mobile}
        offset={offset}
        shouldShrinkToLeft={shouldShrinkToLeft}
      >
        <StyledLoader loading={isFetching} size={20} paddingTop={0}>
          {items.map((child, index) => {
            const [{ default_icon, default_color }] = child?.display_names
              ?.custom_objects ?? [
              {
                default_icon: 'bars-light',
                default_color: 'var(--color-viz-cat-2-primary)',
              },
            ];
            return (
              <Child
                key={`${parent.id}-${child.path}-${index}`}
                full
                as={NavLink}
                to={child.path}
                exact
                hoverColor={default_color}
              >
                <IconContainer className={child.path}>
                  <NavIcon icon={iconOptionsLookup[default_icon]} />
                </IconContainer>
                <TextEllipsisWithTooltip>
                  {getLabel(child)}
                </TextEllipsisWithTooltip>
              </Child>
            );
          })}
          {!items.length ? (
            <Notice key={`${parent.id}-empty`} full as={'div'}>
              <TextEllipsisWithTooltip>
                {t('No Recent Records')}
              </TextEllipsisWithTooltip>
            </Notice>
          ) : null}
        </StyledLoader>
      </ChildrenContainer>
    );
  }
);
